import { CS } from "../../../../base/utils/styler";

export const simpleInputStyle: CS = {
    padding: '8px',
    position: 'relative',
    border: '1px solid #ccc',
    fontSize: '16px',
    borderRadius: '8px',
    width: '300px',
    boxSizing: 'border-box',
    '&:focus': {
        borderColor: '#aaa',
        outline: 'none'
    },
    '&:after': {
        // triangle to the right
        content: '""',
        position: 'absolute',
        top: '10px',
        right: '10px',
        width: '0',
        height: '0',
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent',
        borderBottom: '5px solid #ccc',
    }
}